import { render, staticRenderFns } from "./CouponCoinsPreview.vue?vue&type=template&id=5b167d03&scoped=true&"
import script from "./CouponCoinsPreview.vue?vue&type=script&lang=ts&"
export * from "./CouponCoinsPreview.vue?vue&type=script&lang=ts&"
import style0 from "./CouponCoinsPreview.vue?vue&type=style&index=0&id=5b167d03&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b167d03",
  null
  
)

export default component.exports